import MealItem from './meal-item';
import {
  BaseEntity,
  JsonApiProperty,
  JsonApiRelationship,
  JsonApiResource,
} from '../jsonapi-provider';

@JsonApiResource({
  type: 'meal-additional',
})
export default class MealAdditional extends BaseEntity {
  @JsonApiProperty({ type: 'string' }) serveType?: 'Deli' | 'Congregate' | 'Tray';

  @JsonApiRelationship('meal-item') mealItem: MealItem;

  constructor(
    id?: MealAdditional['id'],
    serveType?: MealAdditional['serveType'],
    mealItem?: MealAdditional['mealItem']
  ) {
    super();
    this.id = id;
    this.serveType = serveType;
    this.mealItem = mealItem ?? new MealItem();
  }
}
